// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import { Box, Flex, Stack, Text } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';

export const VersionRequiredHelp = ({ versionRequired }: { versionRequired: string }) => (
  <Box bg="gray.1" mb="lg" p="lg" style={{ borderRadius: 12 }}>
    <Flex gap="lg">
      <EvolveIcon icon="BarChart" size="xl" color="primary" />
      <Stack gap={0} fz="sm">
        <Text>
          Data will begin to populate upon users installing EVOLVE Electrical/Mechanical version {versionRequired} or
          newer.
        </Text>
        <Text>
          <a
            className="link"
            href="https://help-foresite.evolvemep.com/article/bnb2x617zl"
            target="_blank"
            rel="noreferrer"
          >
            Get help with install
          </a>{' '}
          or click{' '}
          <a className="link" href="https://evolvemep.com/downloads" target="_blank" rel="noreferrer">
            here
          </a>{' '}
          to access the latest EVOLVE version.
        </Text>
      </Stack>
    </Flex>
  </Box>
);
